import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { CONTENT } from "./content";

const LanguageContext = createContext(null);
const STORAGE_KEY = "sj_lang";

const getInitialLang = () => {
  try {
    const saved = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (saved === "pt" || saved === "en") return saved;
  } catch (e) {
    /* ignore storage errors */
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const persist = useCallback((next) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore storage errors */
    }
  }, []);

  const setLang = useCallback((next) => {
    setLangState(next);
    persist(next);
  }, [persist]);

  const toggle = useCallback(() => {
    setLangState((l) => {
      const next = l === "en" ? "pt" : "en";
      persist(next);
      return next;
    });
  }, [persist]);

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = CONTENT[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
